import { DateTime } from 'luxon';
import type { ILeg } from '../../../models/pa-egna-ben/leg.model';

export class LegApiModel {
  public id!: number;
  public number!: number;
  public startTime!: string;
  public endTime!: string;
  public qualificationLimit!: number;

  public static mapToBusinessModel(apiModel: LegApiModel): ILeg {
    return {
      id: apiModel.id,
      number: apiModel.number,
      startTime: DateTime.fromISO(apiModel.startTime),
      endTime: DateTime.fromISO(apiModel.endTime),
      qualificationLimit: apiModel.qualificationLimit,
    };
  }
}

